module.exports = __webpack_public_path__ + "static/genius-e3a83b1ad9506dc649120556a5cb818a.jpg";